import React from 'react';

import { Box } from '@mui/material';

import { useSelector } from '../../redux/store';
import useResponsive from '../../hooks/useResponsive';
import { Permissions } from '../../@types/auth/constants/permissions';
import { FolderActions } from '../../@types/dlx-drive/enums/FolderActions';
import PermissionCheck from '../../components/access-checks/PermissionCheck';
import DocumentsUploadWidget from '../documents/upload/DocumentsUploadWidget';
import DLXDriveDocumentActionsFillForm from './settings/DLXDriveDocumentActionsFillForm';

// --------------------------------------------------------

type DLXDriveDocumentActionsProps = {
  folderId: number;
};

const FolderDocumentActions: React.FC<DLXDriveDocumentActionsProps> = ({ folderId }) => {
  const { selectedFolder } = useSelector((state) => state.dlxDrive);
  const isMobile = useResponsive('only', 'xs');

  return (
    <Box
      sx={[
        {
          width: '100%',
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'stretch',
          flexWrap: 'wrap',
        },
        isMobile
          ? {
              gap: 1,
            }
          : {
              gap: 2,
            },
      ]}
    >
      <PermissionCheck permissions={[Permissions.ComposeDocument]}>
        {selectedFolder.actions.includes(FolderActions.FileUpload) && (
          <DocumentsUploadWidget folderId={folderId} />
        )}
      </PermissionCheck>

      {selectedFolder.actions.includes(FolderActions.FormCreate) && (
        <DLXDriveDocumentActionsFillForm folderId={folderId} />
      )}
    </Box>
  );
};

export default FolderDocumentActions;
